import React from 'react';

function TermsOfService() {
  return (
    <div style={{ 
      maxWidth: '900px', 
      margin: '50px auto', 
      padding: '40px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333',
      textAlign: 'left',
      background: '#fff',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      borderRadius: '8px'
    }}>
      <h1 style={{ color: '#667eea', marginBottom: '10px' }}>Terms of Service</h1>
      <p style={{ color: '#64748b', marginBottom: '30px' }}><em>Last updated: January 28, 2026</em></p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>1. Service Description</h2>
      <p>LaTeXLab provides an online LaTeX editor for creating academic documents. The service is currently in BETA.</p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>2. User Responsibilities</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>You are responsible for all content you upload and create</li>
        <li style={{ marginBottom: '8px' }}>Do not upload copyrighted, illegal, or malicious content</li>
        <li style={{ marginBottom: '8px' }}>Keep your password secure - we are not responsible for unauthorized access</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>3. Data & Privacy</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>Your documents are private and only accessible to you</li>
        <li style={{ marginBottom: '8px' }}>We do not claim ownership of your content</li>
        <li style={{ marginBottom: '8px' }}><strong>IMPORTANT:</strong> This is BETA software - always backup important work locally</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>4. Service Availability</h2>
      <ul style={{ paddingLeft: '20px' }}>
        <li style={{ marginBottom: '8px' }}>Service provided "AS IS" without warranties</li>
        <li style={{ marginBottom: '8px' }}>We may experience downtime during beta phase</li>
        <li style={{ marginBottom: '8px' }}>We are not liable for data loss - backup your work</li>
      </ul>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>5. Account Termination</h2>
      <p>We reserve the right to terminate accounts that violate these terms or engage in abusive behavior.</p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>6. Changes to Terms</h2>
      <p>We may update these terms. Continued use means you accept the changes.</p>
      
      <h2 style={{ color: '#1e293b', marginTop: '30px', marginBottom: '15px' }}>Contact</h2>
      <p>Questions? Use the Feedback button in the app or email us at support@latexlab.com</p>
      
      <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #e2e8f0', textAlign: 'center' }}>
        <a href="/" style={{ color: '#667eea', textDecoration: 'none' }}>← Back to Home</a>
      </div>
    </div>
  );
}

export default TermsOfService;
